import header from '~/mixins/header.js'
import debounce from 'lodash.debounce'

export default {
  mixins: [header],

  props: {
    notificationBar: {
      type: Object,
    },
  },

  data() {
    return {
      previousScrollPositionY: 0,
      header: null,
      hero: null,
      unpinned: false,
      solid: false,
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.header = document.querySelector('.header')
      this.page = document.querySelector('.page')

      let { y: previousScrollPositionY } = this.scrollPosition()
      this.previousScrollPositionY = previousScrollPositionY

      window.addEventListener('scroll', this.scroll, { capture: true, passive: true })
      window.dispatchEvent(new Event('scroll'))
    })
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll)
  },

  computed: {
    hasLogoLabel() {
      return !!this.navigation?.logo?.label
    },
  },

  methods: {
    scroll(e) {
      this.scrollDebounce(e, this)
    },

    scrollDebounce: debounce((e, self) => {
      const { y: currentScrollPositionY } = self.scrollPosition()

      if (self.isScrollDown() && self.isOutsideSafetyMarginHeader()) self.unpinned = true
      if (self.isScrollUp()) {
        self.unpinned = false
        if (self.isOutsideSafetyMarginHeader()) self.solid = true
        else self.solid = false
      }

      self.previousScrollPositionY = currentScrollPositionY
    }, 16),

    scrollPosition() {
      let scrollPositionY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      const scrollMinY = 0
      const scrollMaxY =
        window.scrollMaxY || document.documentElement.scrollHeight - document.documentElement.clientHeight

      if (scrollPositionY < scrollMinY) scrollPositionY = scrollMinY
      if (scrollPositionY > scrollMaxY) scrollPositionY = scrollMaxY

      return {
        y: scrollPositionY,
      }
    },

    isScrollDown() {
      const { y: currentScrollPositionY } = this.scrollPosition()
      const isScrollDown = this.previousScrollPositionY < currentScrollPositionY

      return isScrollDown
    },

    isScrollUp() {
      return !this.isScrollDown()
    },

    isOutsideSafetyMarginHeader() {
      const { height: headerHeight } = this.header.getBoundingClientRect()
      const { top: pageOffsetTop } = this.page.getBoundingClientRect()
      const headerSafetyMargin = headerHeight / 2

      return headerSafetyMargin < -pageOffsetTop
    },
  },
}
